<template>
  <div
    v-if="data"
    :class="$style.root"
  >
    <core-text-component
      v-if="data?.richText"
      :class="$style.introduction"
      :string="data.richText"
    />

    <pages-editions-slug-parent-nav-component
      :class="$style.nav"
      :entries="entries?.data"
    />

    <div :class="$style.prevNextContainer">
      <transition name="fade">
        <pages-editions-slug-parent-prev-next-component
          v-if="prevEntry?.slug"
          :entry="prevEntry"
          dir="prev"
        />
      </transition>

      <transition name="fade">
        <pages-editions-slug-parent-prev-next-component
          v-if="nextEntry?.slug"
          :entry="nextEntry"
          dir="next"
        />
      </transition>
    </div>

    <pages-editions-slug-parent-titles-component
      :class="$style.carousel"
      :entries="entries?.data"
      :edition-index="editionIndex"
    />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  editionIndex: Number
})

// fetch biennial page
const { data, error } = await useAsyncData(() => $fetch('/api/strapi-rest', { query: { path: queryBiennialPage(getPageQuery()) } }  ) )

data.value = getFirstObject(data.value)

// fetch biennial entries
const { data: entries, error: entriesError } = await useAsyncData(() => $fetch('/api/strapi-rest', { query: { path: queryBiennialEntriesThumbnailBasic(getPageQuery()) } }  ) )

// fetch prev next
const route = useRoute()
const slug = computed(() => route.params.slug)

const prevEntry = computed(() => {
  const index = entries?.value?.data?.findIndex(entry => entry?.slug === slug?.value)
  return entries.value?.data[index - 1]
})

const nextEntry = computed(() => {
  const index = entries?.value?.data?.findIndex(entry => entry?.slug === slug?.value)
  return entries.value?.data[index + 1]
})
</script>

<style module lang="scss">
.root {
  position: relative;
}

.introduction {
  composes: container font-size-small from global;
  margin-bottom: calc(var(--unit--vertical) * 2);
}

.nav {
  margin-bottom: calc(var(--unit--vertical) * 2);
}

.carousel {
  width: 100%;
}

.prevNextContainer {
  @media (max-width: $breakpoint-xs) {
    display: flex;
    padding: var(--unit--vertical) var(--unit--horizontal);
    margin-bottom: calc(var(--unit--vertical) * 2);

    [dir='next'] {
      margin-left: auto;
    }
  }
}
</style>
